import { apiUrl } from "../config";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || apiUrl;

function getAuthHeaders() {
  const token = localStorage.getItem("access_token");
  // csrf: meta tag first, then cookie
  const meta = document.querySelector('meta[name="csrf-token"]');
  const csrf = meta?.getAttribute("content")
    || document.cookie.split(";").map((c) => c.trim())
        .find((c) => c.startsWith("csrf_token="))?.substring("csrf_token=".length)
    || "";
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(csrf ? { "X-CSRF-Token": decodeURIComponent(csrf) } : {}),
  };
}

export async function apiFetch(path, options = {}) {
  return fetch(`${API_BASE_URL}${path}`, {
    credentials: "include",
    ...options,
    headers: {
      ...getAuthHeaders(),
      ...(options.headers || {}),
    },
  });
}

export async function apiGetJson(path) {
  const res = await apiFetch(path, { method: "GET" });
  if (!res.ok) throw new Error(await res.text());

  // check if response is JSON before parsing
  const contentType = res.headers.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    const text = await res.text();
    throw new Error(
      `Expected JSON response but got: ${text.substring(0, 100)}`
    );
  }

  return res.json();
}

export async function apiPostJson(path, body) {
  const res = await apiFetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!res.ok) throw new Error(await res.text());

  try {
    return await res.json();
  } catch {
    return null;
  }
}
